import clsx from "clsx";
import { useEffect, useState } from "react";
import { demoString } from "../../../utils/demo";
import { getAdminParams } from "../../utils";
import { Infotip } from "../../../shared/Infotip";
import { RowDataInterface } from "../ReportTypes";

const ProgressHeaderCard = ({
  dataScope,
  title,
  meta,
  sameSchool,
}: {
  dataScope: string;
  title: string;
  meta?: RowDataInterface["meta"] | null;
  sameSchool?: boolean;
}) => {
  const admin = getAdminParams();
  const [showSchools, setShowSchools] = useState(true);

  useEffect(() => {
    if (
      admin.account_type === "school" ||
      admin.account_type === "super_school"
    ) {
      if (admin.schoolIDs.length <= 1) {
        setShowSchools(false);
      }
    }
  }, [admin]);

  // Helper to generate infotip message content
  const getInfotipMessage = () => {
    if (dataScope === "Teachers" && showSchools && admin.schoolIDs.length > 1) {
      if (
        (!Array.isArray(meta?.schools) && !meta?.schools) ||
        (Array.isArray(meta?.schools) &&
          (!meta?.schools || meta?.schools.length === 0))
      ) {
        return null;
      }
      return (
        <span className="text-xs text-gray-200">
          {!Array.isArray(meta?.schools) && meta?.schools && (
            <p>
              -{demoString({ value: meta?.schools[0], type: "school_name" })}
            </p>
          )}
          {Array.isArray(meta?.schools) &&
            meta?.schools &&
            meta?.schools.length > 1 && (
              <p>
                -
                {demoString({
                  value: meta?.schools[0],
                  type: "school_name",
                })}
                ...
              </p>
            )}
        </span>
      );
    }
    if (dataScope === "Sections") {
      const hasSchools =
        sameSchool &&
        Array.isArray(meta?.schools) &&
        meta?.schools &&
        meta?.schools.length > 0;
      const hasTeachers =
        Array.isArray(meta?.teachers) &&
        meta?.teachers &&
        meta?.teachers.length > 0;

      if (!hasSchools && !hasTeachers) return null;

      return (
        <span className="text-xs text-gray-200">
          {sameSchool &&
            Array.isArray(meta?.schools) &&
            meta?.schools?.length === 1 && (
              <p>
                -{demoString({ value: meta?.schools[0], type: "school_name" })}
              </p>
            )}
          {sameSchool &&
            Array.isArray(meta?.schools) &&
            meta?.schools &&
            meta?.schools?.length > 1 && (
              <p>
                -{demoString({ value: meta?.schools[0], type: "school_name" })}
                ...
              </p>
            )}
          {Array.isArray(meta?.teachers) &&
            meta?.teachers &&
            meta?.teachers?.length === 1 && (
              <p>
                -{demoString({ value: meta?.teachers[0], type: "person_full" })}
              </p>
            )}
          {Array.isArray(meta?.teachers) &&
            meta?.teachers &&
            meta?.teachers.length > 1 && (
              <div>
                {meta?.teachers
                  ?.filter((t) => t !== undefined)
                  .map((teacher, index: number) => (
                    <p className="w-full" key={index}>
                      {demoString({ value: teacher, type: "person_full" })}
                    </p>
                  ))}
              </div>
            )}
        </span>
      );
    }
    return null;
  };

  const infotipMessage = getInfotipMessage();

  return (
    <div className="justify-left flex h-full items-center border-b-2 p-4">
      {title === "Total" ? (
        <span
          className={clsx("text-xl font-bold", "font-semibold sm:col-span-1")}
        >
          Total
        </span>
      ) : infotipMessage ? (
        <Infotip
          message={infotipMessage}
          options={{
            aligned: "center",
            maxWidth: 220,
            raise: "-top-20",
          }}
          ariaLabel="Show details"
        >
          <span
            className={clsx(
              "font-semibold sm:col-span-1",
              dataScope === "Schools"
                ? "text-left"
                : dataScope === "Sections"
                ? "text-left"
                : ""
            )}
          >
            {dataScope === "Schools"
              ? demoString({ value: title, type: "school_name" })
              : dataScope === "Sections"
              ? demoString({ value: title, type: "section_name" })
              : demoString({ value: title, type: "person_full" })}
          </span>
        </Infotip>
      ) : (
        <span
          className={clsx(
            "font-semibold sm:col-span-1",
            dataScope === "Schools"
              ? "text-left"
              : dataScope === "Sections"
              ? "text-left"
              : ""
          )}
        >
          {dataScope === "Schools"
            ? demoString({ value: title, type: "school_name" })
            : dataScope === "Sections"
            ? demoString({ value: title, type: "section_name" })
            : demoString({ value: title, type: "person_full" })}
        </span>
      )}
    </div>
  );
};

export default ProgressHeaderCard;
